<template>
  <div id="analise">
    <div class="contant-analise" v-if="!error">
      <h1 class="titulo">{{titulo}}</h1>
      <p class="subtitulo">{{subtitulo}}</p>
      <div class="animacao">
        <img class="img img-fluid" src="@/assets/img/analise/meuvivo.gif">
      </div>
    </div>

    <div class="page-error" v-if="error">
      <Error
          title="Algo deu errado ao enviar a foto"
          :subtitle="errorSubtitulo"
          button-text="Tentar de novo"
          v-bind:callback="enviarDados"
      ></Error>
    </div>
  </div>
</template>

<script>

import CapturaService from "../../services/CapturaService";
import Error from "../shared/Error";

const TEXTO = {
  preprando: "Preparando foto para envio",
  analisando:"Analisando foto enviada",
  enviando: "Enviando foto pra análise"
}

export default {
  name: "Analise",
  components: {Error},
  data:function (){
    return {
      titulo: TEXTO.preprando,
      subtitulo: 'Continue nesta tela enquanto analisamos',
      errorSubtitulo:'',
      error: false,
      tentativa:1,
      redirectDoc:false,
      redirectSelfie:false
    }
  },
  computed:{
    getDados:function (){
      return this.$store.getters.dados;
    }
  },
  mounted() {
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTitulo','Confirmar identidade');
    this.enviarDados();
  },
  methods:{
    enviarDados:function (){
      if(this.redirectSelfie){
        this.redirectSelfie = false;
        this.$router.replace({name: 'ConfirmarIdentidade'});
        return;
      }

      if(this.redirectDoc){
        this.redirectDoc = false;
        this.$router.replace({name: 'DocSelecao'});
        return;
      }

      this.titulo = TEXTO.preprando;
      this.error = false;
      let capturaService = new CapturaService();
      let dados  = this.getDados;

      dados.link_codigo = this.$store.state.link_codigo;
      dados.link_hrefer = this.$store.state.link_hrefer;
      dados.link_origem = this.$store.state.link_origem;
      dados.selfie = sessionStorage.getItem('s');
      dados.selfie_msg = sessionStorage.getItem('selfie_msg');
      dados.selfie_id = sessionStorage.getItem('selfie_id');

      if(!dados.selfie || (!dados.is_caf && !this.validarArquivo(dados.selfie))){
        this.redirectSelfie = true;
        this.errorSubtitulo = "Não conseguimos recuperar sua selfie, você vai precisar capturar ela novamente";
        this.error = true
        sessionStorage.removeItem('s');
        return;
      }

      if(this.$store.getters.tipoCaptura === 1){
        let d = {
          docA: sessionStorage.getItem('A'),
          docB: sessionStorage.getItem('B'),
          docAB: sessionStorage.getItem('AB'),
          docCNHDIGITAL: this.$store.getters.dados.cnh_digital_base
        };


        Object.keys(d).forEach(key => {
          const value = d[key];
          if (
              value === undefined ||
              value === null ||
              (typeof value === 'string' && value.trim() === '')
          ) {
            delete d[key];
          }else if(!this.validarArquivo(value,(key == 'docCNHDIGITAL'))){
            delete d[key];
          }
        });

        if(this.isObjectEmpty(d)){
          this.redirectDoc = true;
          this.errorSubtitulo = "Não conseguimos recuperar as fotos do seu documento, você vai precisar capturar elas novamente.";
          this.error = true;
          return;
        }
        dados = Object.assign({}, dados, d);
      }

      this.titulo = TEXTO.enviando;
      capturaService.enviarDigitalizacao(dados)
          .then(result => {
            if(result.type === "error") {
              return Promise.reject(result);
            }
            if(result.enviarMotor && parseInt(dados.ind_excecao_pre_pago) === 2){
              return capturaService.enviarMotorBio(dados.chave,result.protocolo);
            }
            return Promise.resolve();
          })
          .then(_  =>  {
            this.titulo = TEXTO.analisando;
            this.redireciona(false)
          })
          .catch(error => {
            if(error.type && error.type === "error") {
              this.errorSubtitulo = error.description;
              this.error = true
              return;
            }

            this.redireciona(true);
          });
    },
    validarArquivo:function (dataurl,isPdf = false){
      try{
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File([u8arr], 'testefile', {type:mime});
        let types = (isPdf) ? ['application/pdf'] : ['image/jpeg','image/tiff','image/png'];
        return types.includes(file.type);
      }catch (e) {
        return false;
      }
    },
    tratarURL(url){
      if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
          return `https://${url}`;
      }
      return url;
    },
    redireciona:function (error){
      var isJornadaCompleta = this.$store.getters.isJornadaCompleta ? 'doc' : 'selfie'
      //Posição [0] = callback de sucesso
      //Posição [1] = callback de falha
      var URL_RETORNO =  this.$store.getters.getUrlRetorno.split('$');
      var url = (error) ? URL_RETORNO[1] : URL_RETORNO[0];
      var checkParams = this.checkUrlParams(url)
      var tipoCaptura = checkParams ? '&typeBiometry=' : '?typeBiometry='

      sessionStorage.clear();
      this.$store.dispatch('resetState');

      window.location.replace(this.tratarURL(url) + tipoCaptura + isJornadaCompleta);

    },
    checkUrlParams: function (url) {
      return url.match(/[?&][^&=]+(=[^&]*)?/g)
    },
    isObjectEmpty:function (obj){
      return Object.values(obj).every(value => value === undefined || value === null || value === '');
    }
  },
}
</script>

<style scoped>


.hidden{
  display: none;
}

#analise{
  margin-top: 40px;
}

.animacao {
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;
}

.animacao img {
  position: relative;
  height: 100%;
  margin: 0 auto;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Analise.vue